import { render, staticRenderFns } from "./rating-picker.vue?vue&type=template&id=8b4ef608&scoped=true&"
import script from "./rating-picker.vue?vue&type=script&lang=js&"
export * from "./rating-picker.vue?vue&type=script&lang=js&"
import style0 from "./rating-picker.vue?vue&type=style&index=0&id=8b4ef608&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4ef608",
  null
  
)

export default component.exports